import React, { Component } from 'react';
import { Modal, Table } from 'antd';
import { observer, inject } from 'mobx-react';

@inject('appStrategyStore')
@observer
class AppProgressModal extends Component {
  render() {
    const {
      AppProgressModalStatus,
      hideAppProgressModal,
      AppProgressModalData
    } = this.props.appStrategyStore;
    const appCols = [
      {
        title: '设备编号',
        key: 'device_id',
        dataIndex: 'device_id',
        width: 100
      },
      { title: '更新状态', dataIndex: 'status', key: 'status', width: 250 },
      {
        title: '应用时间',
        dataIndex: 'complete_time',
        key: 'complete_time',
        width: 100
      }
    ];
    return (
      <div>
        <Modal
          visible={AppProgressModalStatus}
          onCancel={hideAppProgressModal}
          footer={null}
          title={'APP应用进度'}
          width={'50%'}
        >
          <Table
            scroll={{ y: 600 }}
            dataSource={[...AppProgressModalData]}
            columns={appCols}
          />
        </Modal>
      </div>
    );
  }
}

export default AppProgressModal;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/AppProgressModal.js